import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import { route } from "./utils/MainRout";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(route);

// 401 hatalarını global olarak yakala — interceptor zaten logout yapıyor,
// unhandled rejection olarak React error overlay'e düşmesin
window.addEventListener('unhandledrejection', (event) => {
  // Token yokken interceptor'in iptal ettigi istekler ve 401'ler zaten
  // ele aliniyor; React error overlay'e dusmesinler.
  if (axios.isCancel(event.reason) || event.reason?.response?.status === 401) {
    event.preventDefault();
  }
});

// Service Worker kaydı
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Sayfa yüklendiğinde mevcut controller var mıydı?
    // Varsa → güncelleme demek → controllerchange'de reload et
    // Yoksa → ilk kurulum → gereksiz reload yok
    const hadController = !!navigator.serviceWorker.controller;

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing || !hadController) return;
      refreshing = true;
      window.location.reload();
    });

    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        registration.update();
      })
      .catch(() => {});
  });
}
